/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Extract_AudioInputs */

const en_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to extract audio from source file`)
};

const fr_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’extraction audio du fichier source`)
};

const de_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Extrahieren der Audiodatei aus der Quelldatei`)
};

const it_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile estrarre l'audio dal file sorgente`)
};

const ru_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось извлечь аудио из исходного файла.`)
};

const es_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo extraer el audio del archivo fuente`)
};

const zh_cn2_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法从源文件中提取音频`)
};

const ja_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースファイルからオーディオを抽出できませんでした`)
};

const hi_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत फ़ाइल से ऑडियो निकालने में विफल`)
};

const pt_pt2_failed_to_extract_audio = /** @type {(inputs: Failed_To_Extract_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao extrair o áudio do arquivo de origem`)
};

/**
* | output |
* | --- |
* | "Failed to extract audio from source file" |
*
* @param {Failed_To_Extract_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_extract_audio = /** @type {((inputs?: Failed_To_Extract_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Extract_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_extract_audio(inputs)
	if (locale === "de") return de_failed_to_extract_audio(inputs)
	if (locale === "it") return it_failed_to_extract_audio(inputs)
	if (locale === "ru") return ru_failed_to_extract_audio(inputs)
	if (locale === "es") return es_failed_to_extract_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_extract_audio(inputs)
	if (locale === "ja") return ja_failed_to_extract_audio(inputs)
	if (locale === "hi") return hi_failed_to_extract_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_extract_audio(inputs)
	return en_failed_to_extract_audio(inputs)
});